import { Setting } from '../models';
import Utils from './Utils';

export function usable_image_url(url) {
    if (typeof url !== 'string')
        return '';
    const trimmed = url.trim();
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null')
        return '';
    return trimmed;
}

export function instance_logo_url(setting, lang, max_width = null, max_height = null) {
    if (!setting) {
        return '';
    }
    const model = setting instanceof Setting ? setting : new Setting(setting);
    const image = model.findImage?.(Utils.IMAGE_TYPE_LOGO, lang);
    const url = usable_image_url(image?.url) || usable_image_url(image?.rfc2397_data);
    if (!url) {
        return '';
    }
    return Utils.imgProxyUrl(url, max_width, max_height) || '';
}
